/* Vital Years+ — cart drawer & product purchase flow */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = document.querySelector('[data-vy-drawer]');
  var lastFocus = null;

  function money(cents) {
    var fmt = (window.VY && window.VY.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function toast(text) {
    var el = document.querySelector('.vy-toast');
    if (!el) { el = document.createElement('div'); el.className = 'vy-toast'; document.body.appendChild(el); }
    el.textContent = text; el.classList.add('is-visible');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 1800);
  }

  function setCount(n) {
    document.querySelectorAll('[data-vy-cart-count]').forEach(function (c) { c.textContent = n; });
  }

  function refresh() {
    return fetch(root + '?sections=vy-cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json['vy-cart-drawer'];
        if (!html || !drawer) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var next = tmp.querySelector('[data-vy-drawer-content]');
        var cur = drawer.querySelector('[data-vy-drawer-content]');
        if (next && cur) cur.replaceWith(next);
        var count = drawer.querySelector('.vy-drawer__count');
        if (count) setCount(parseInt(count.textContent, 10) || 0);
      });
  }

  function open() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.setAttribute('data-vy-drawer-open', '');
    setTimeout(function () { drawer.querySelector('.vy-drawer__panel').focus(); }, 260);
  }
  function close() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.removeAttribute('data-vy-drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function add(items) {
    return post('cart/add.js', { items: items }).then(function () { return refresh(); }).then(open)
      .catch(function (e) { toast((e && e.description) || 'Could not add to cart'); });
  }

  function change(line, data) {
    return post('cart/change.js', Object.assign({ line: line }, data)).then(refresh)
      .catch(function (e) { toast((e && e.description) || 'Could not update cart'); refresh(); });
  }

  /* ---- open / close */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vy-cart-link]')) { e.preventDefault(); refresh().then(open); }
    if (e.target.closest('[data-vy-drawer-close]')) { close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') close();
  });

  /* ---- product form submit (PDP + home) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.querySelector('[data-vy-add]')) return;
    e.preventDefault();
    var fd = new FormData(form);
    var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
    var planEl = form.querySelector('input[name="vy_plan"]:checked');
    var plan = planEl ? planEl.value : '';
    if (plan) item.selling_plan = parseInt(plan, 10);
    var btn = form.querySelector('[data-vy-add]'); if (btn) btn.setAttribute('aria-disabled', 'true');
    add([item]).then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  /* ---- remote add buttons (sticky bars, CTA card) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vy-add-remote]');
    if (!btn) return;
    var form = document.getElementById('VyProductForm');
    if (!form) return;
    var qtyInput = document.querySelector('[data-vy-qty-input]');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var plan = form.querySelector('input[name="vy_plan"]:checked');
    var item = { id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: qty };
    if (plan && plan.value) item.selling_plan = parseInt(plan.value, 10);
    add([item]);
  });

  /* ---- upsells */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vy-upsell]');
    if (!btn) return;
    add([{ id: parseInt(btn.dataset.vyUpsell, 10), quantity: 1 }]);
  });

  /* ---- line controls */
  document.addEventListener('click', function (e) {
    var lineEl = e.target.closest('[data-vy-line]');
    if (!lineEl) return;
    var line = parseInt(lineEl.dataset.vyLine, 10);
    var qtyEl = lineEl.querySelector('[data-vy-line-qty]');
    var step = e.target.closest('[data-vy-line-step]');
    if (step) { change(line, { quantity: Math.max(0, (parseInt(qtyEl.value, 10) || 0) + parseInt(step.dataset.vyLineStep, 10)) }); return; }
    if (e.target.closest('[data-vy-line-remove]')) { change(line, { quantity: 0 }); return; }
    var planBtn = e.target.closest('[data-vy-line-plan]');
    if (planBtn) {
      var data = { quantity: parseInt(qtyEl.value, 10) || 1 };
      data.selling_plan = planBtn.dataset.vyLinePlan ? parseInt(planBtn.dataset.vyLinePlan, 10) : null;
      change(line, data);
    }
  });
  document.addEventListener('change', function (e) {
    var qtyEl = e.target.closest('[data-vy-line-qty]');
    if (!qtyEl) return;
    var lineEl = qtyEl.closest('[data-vy-line]');
    change(parseInt(lineEl.dataset.vyLine, 10), { quantity: Math.max(0, parseInt(qtyEl.value, 10) || 0) });
  });

  /* ---- note & discount */
  document.addEventListener('change', function (e) {
    var note = e.target.closest('[data-vy-cart-note]');
    if (!note) return;
    post('cart/update.js', { note: note.value });
    var f = document.querySelector('[data-vy-note-field]'); if (f) f.value = note.value;
  });
  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-vy-discount-apply]');
    if (!apply) return;
    var input = document.querySelector('[data-vy-discount]');
    var code = input && input.value.trim();
    if (!code) return;
    document.cookie = 'discount_code=' + encodeURIComponent(code) + '; path=/';
    var form = document.querySelector('[data-vy-checkout-form]');
    if (form) form.action = root + 'cart?discount=' + encodeURIComponent(code);
    toast('Code "' + code + '" will apply at checkout');
  });

  /* ---- PDP: plan + price + sticky bar */
  var pdp = document.querySelector('[data-vy-pdp]');
  if (pdp) {
    var sub = parseInt(pdp.dataset.subPrice, 10), one = parseInt(pdp.dataset.onePrice, 10);
    var form = document.getElementById('VyProductForm');
    var qtyField = form && form.querySelector('[data-vy-qty-field]');
    function currentPlan() { var r = form && form.querySelector('input[name="vy_plan"]:checked'); return r && r.value ? 'subscribe' : 'onetime'; }
    function syncPrice() {
      var qtyInput = document.querySelector('[data-vy-qty-input]');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (qtyField) qtyField.value = qty;
      var card = pdp.hasAttribute('data-vy-ceylance') && form && form.querySelector('input[name="vy_bundle"]:checked');
      if (card) {
        var subRadio = form.querySelector('[data-vy-plan="subscribe"]');
        var oneRadio = form.querySelector('[data-vy-plan="onetime"]');
        var canSub = card.dataset.hasSub === 'true';
        if (subRadio) {
          subRadio.disabled = !canSub;
          if (canSub && card.dataset.plan) subRadio.value = card.dataset.plan;
          if (!canSub && subRadio.checked && oneRadio) oneRadio.checked = true;
        }
        form.querySelector('input[name="id"]').value = card.value;
        pdp.dataset.onePrice = card.dataset.price;
        pdp.dataset.subPrice = canSub ? card.dataset.sub : card.dataset.price;
        var isSub = currentPlan() === 'subscribe';
        form.querySelectorAll('input[name="vy_bundle"]').forEach(function (r) {
          var el = r.closest('.vy-offer__card');
          var useSub = isSub && r.dataset.hasSub === 'true';
          el.querySelector('[data-card-price]').textContent = money(Number(useSub ? r.dataset.sub : r.dataset.price));
          el.querySelector('[data-save-label]').textContent = useSub ? r.dataset.subSave : r.dataset.save;
        });
        var total = Number(isSub ? pdp.dataset.subPrice : pdp.dataset.onePrice) * qty;
        var compare = Number(card.dataset.compare) * qty;
        pdp.querySelectorAll('[data-vy-compare]').forEach(function (el) { el.textContent = money(compare); el.hidden = (!isSub && Number(card.dataset.stack || 1) <= 1) || compare <= total; });
        pdp.querySelectorAll('[data-vy-bundle-label]').forEach(function (el) { el.textContent = card.dataset.title; });
        pdp.querySelectorAll('[data-vy-quantity-label]').forEach(function (el) { el.textContent = qty > 1 ? '× ' + qty : ''; });
        form.querySelectorAll('[data-vy-note]').forEach(function (el) { el.hidden = el.dataset.vyNote !== currentPlan(); });
        form.querySelectorAll('[data-vy-every]').forEach(function (el) { el.textContent = card.dataset.every || 'month'; });
        form.querySelectorAll('[data-vy-renew]').forEach(function (el) { el.textContent = money(Number(card.dataset.renew || card.dataset.sub || card.dataset.price)); });
        form.querySelectorAll('[data-vy-first]').forEach(function (el) { var s = Number(card.dataset.sub || 0), r = Number(card.dataset.renew || 0); el.textContent = (s && r && s < r) ? Math.round((r - s) * 100 / r) + '% off today, then ' : ''; });
        var offerA = form.querySelector('.vy-offer--a');
        if (offerA) {
          offerA.classList.toggle('is-once', !isSub);
          form.querySelectorAll('input[name="vy_bundle"]').forEach(function (r) {
            var el = r.closest('.vy-offer__card');
            var useSub = isSub && r.dataset.hasSub === 'true';
            var p = Number(useSub ? r.dataset.sub : r.dataset.price), st = Math.max(1, Number(r.dataset.stack || 1));
            var pp = el.querySelector('[data-card-pp]'); if (pp) pp.textContent = 'Only ' + money(Math.floor(p / (st * 30))) + ' a day';
            var showDeal = useSub || st > 1;
            var sv = el.querySelector('[data-card-saved]'); if (sv) { var d = Number(r.dataset.compare) - p; sv.textContent = 'You save ' + money(d); sv.hidden = !showDeal || d <= 0; }
            var cs = el.querySelector('.vy-offer__price s'); if (cs) cs.hidden = !showDeal;
            var sg = el.querySelector('.vy-offer__save'); if (sg) sg.hidden = !showDeal;
            var th = el.querySelector('[data-card-then]'); if (th) th.hidden = !useSub;
          });
          offerA.querySelectorAll('[data-vy-once]').forEach(function (b) { b.setAttribute('aria-pressed', isSub ? 'false' : 'true'); });
          offerA.querySelectorAll('[data-vy-once-price]').forEach(function (el) { el.textContent = money(Number(card.dataset.price)); });
          offerA.querySelectorAll('[data-vy-cta-sub]').forEach(function (el) { el.textContent = isSub ? 'Subscription · skip or cancel anytime' : 'One-time purchase · free shipping'; });
        }
        pdp.querySelectorAll('[data-vy-seg="subscribe"]').forEach(function (el) { el.disabled = !canSub; });
        pdp.querySelectorAll('[data-vy-add-remote], [data-vy-add]').forEach(function (el) { el.disabled = card.disabled; });
      }
      var unit = currentPlan() === 'subscribe' ? (parseInt(pdp.dataset.subPrice, 10) || sub) : (parseInt(pdp.dataset.onePrice, 10) || one);
      document.querySelectorAll('[data-vy-price]').forEach(function (el) { el.textContent = money(unit * qty); });
      document.querySelectorAll('[data-vy-seg]').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.vySeg === currentPlan() ? 'true' : 'false'); });
      document.querySelectorAll('[data-vy-plan-label]').forEach(function (label) { label.textContent = currentPlan() === 'subscribe' ? 'Subscribe & save' : 'One-time purchase'; });
    }
    document.addEventListener('change', function (e) {
      if (e.target.matches('input[name="vy_bundle"]') && form && form.querySelector('.vy-offer--a')) {
        var sr = form.querySelector('[data-vy-plan="subscribe"]');
        if (sr && !sr.disabled) sr.checked = true;
      }
      if (e.target.matches('input[name="vy_plan"]') || e.target.matches('[data-vy-qty-input]') || (pdp.hasAttribute('data-vy-ceylance') && e.target.matches('input[name="vy_bundle"]'))) syncPrice();
    });
    document.addEventListener('click', function (e) {
      var onceBtn = e.target.closest('[data-vy-once]');
      if (onceBtn && form) {
        var toOnce = onceBtn.getAttribute('aria-pressed') !== 'true';
        var target = form.querySelector('[data-vy-plan="' + (toOnce ? 'onetime' : 'subscribe') + '"]');
        if (target && !target.disabled) { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); }
        return;
      }
      var seg = e.target.closest('[data-vy-seg]');
      if (!seg || seg.disabled) return;
      var radio = form.querySelector('[data-vy-plan="' + seg.dataset.vySeg + '"]');
      if (radio && !radio.disabled) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    try {
      var wanted = new URLSearchParams(location.search).get('plan');
      if (wanted === 'subscribe' || wanted === 'onetime') { var pre = form && form.querySelector('[data-vy-plan="' + wanted + '"]'); if (pre && !pre.disabled) pre.checked = true; }
    } catch (e) {}
    syncPrice();

    var sticky = document.querySelector('[data-vy-sticky]');
    var hero = document.querySelector('.vy-pdp__hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }, { threshold: 0 }).observe(hero);
    }
  }

  window.VYCart = { open: open, close: close, refresh: refresh, add: add };
})();


